import React from 'react'
import FontIcon from '@material-ui/core/Icon'
import Button from '@material-ui/core/Button'
import { TextField, DialogTitle } from '@material-ui/core'
import { useForm } from 'react-hook-form'
import { inject, observer } from 'mobx-react'
import { flow } from 'lodash'
import i18next from 'i18next'

import InvitationsApi from '../../api/InvitationsApi'
import withTranslation from '../hocs/withTranslation'

const InvitationDialog = ({ t, user, showDialog }) => {
  const { register, handleSubmit, watch, formState: { errors, isSubmitting } } = useForm()
  const emails = watch('emails')

  const onSubmit = ({ emails: emailsStr }) => {
    const arrayedEmails = emailsStr.split(',').map((e) => e.trim()).filter(Boolean)

    const promises = arrayedEmails.map((email) =>
      InvitationsApi.create({
        recipientEmail: email,
        senderId: user?.id,
        locale: i18next.language
      })
    )

    return Promise.all(promises).then(() => {
      showDialog('invitation', { step: 2 })
    })
  }

  return (
    <div>
      <DialogTitle disableTypography>{t('invitation.invite')}</DialogTitle>

      <section className='pane thin-reg-pane'>
        <div className='row reg-bottom'>
          <div className='col-xs-12 center-xs'>
            <div className='box'>
              <FontIcon className='fal fa-envelope-open-text header-36' />
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col-xs-12 center-xs'>
            <h1 className='flat header-24'>{t('invitation.inviteByEmail')}</h1>
          </div>
        </div>
      </section>

      <section className='pane minimal-grey-pane big-top-padding big-bottom-padding'>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className='row reg-bottom'>
            <div className='col-xs-12'>
              <TextField
                {...register('emails', { required: true })}
                label={t('conversation.emailLabel')}
                helperText={errors.emails ? t('common.required') : t('conversation.emailHint')}
                error={!!errors.emails}
                fullWidth
                margin='normal'
              />
            </div>
          </div>

          <div className='row center-xs fat-top'>
            <div className='col-xs-12'>
              <Button
                type='submit'
                className='reg-bottom flat-top btn-xl btn-block lowercase capitalize'
                disabled={!emails || isSubmitting}
                variant='contained'
                color='primary'
              >
                {t('conversation.sendInvite')}
              </Button>
            </div>
          </div>
        </form>
      </section>
    </div>
  )
}

export default flow(
  withTranslation,
  observer,
  inject(({ mst: { auth: { user }, dialogs: { showDialog } } }) => ({
    user,
    showDialog
  }))
)(InvitationDialog)
